// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"Purchase_breadCrumbs__Lqdk9","container":"Purchase_container__1zEn6","title":"Purchase_title__tBC_l"};